<template>
  <div class="content">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('generationCourse.back') }}</span>
    </div>
    <div ref="main" class="main">
      <div class="left" ref="left">
        <CourseGenerationConfig ref="config" :outputCompleted="outputCompleted" @ok="generate" @clear="clearForm" />
      </div>
      <!-- 输入区域 -->
      <div class="right" ref="right">
        <div class="timeout" v-if="isTimeout">
          <img src="@/assets/img/icon_timeout@3x.png" alt="" srcset="" />
        </div>
        <template v-else>
          <div v-if="tempMessage == ''" class="loading" style="color: #F59363">
            <img src="@/assets/img/ai_loading.png" style="margin-bottom: 12px;" alt="" srcset="" />
            {{ $t('generationCourse.waitingGeneration') }}
          </div>
          <div v-else>
            <div class="outline" ref="outline">
              <div class="cover">
                <img src="@/assets/icons/icon_ai_cover@2x.png" alt="" srcset="" />
              </div>
              <div class="content">
                <vue-markdown
                  :source="tempMessage"
                  class="markdown-body vue-markdown"
                  v-if="!outputCompleted"
                  :options="{ breaks: true }"
                />
                <!-- <pre v-if="!outputCompleted">
                  {{ tempMessage }}
                </pre> -->
                <div class="markdown-body completed" v-else>
                  <draggable
                    v-model="outlineMessage"
                    group="people"
                    @start="drag = true"
                    @end="drag = false"
                    :move="checkMove"
                    handle=".dragIcon"
                    :animation="200"
                  >
                    <div v-for="(item, index) in outlineMessage" :key="item.id">
                      <h2 @dblclick="editItem(item, 'h2')">
                        <a-input
                          v-if="item.editing && item.level === 2"
                          v-model="item.title"
                          @blur="saveEdit(item)"
                          autofocus
                        />
                        <div class="title" v-else>{{ item.title }}</div>
                        <div class="action-buttons">
                          <a-icon type="drag" style="cursor: move;" class="dragIcon" />
                          <!-- <a-icon type="delete" @click="deleteItem(item, index, 'h2')" /> -->
                          <img
                            src="@/assets/icons/icon_sc.png"
                            alt=""
                            srcset=""
                            style="width: 16px;"
                            @click="deleteItem(item, index, 'h2')"
                          />
                        </div>
                      </h2>
                      <draggable
                        v-model="item.children"
                        group="people"
                        @start="drag = true"
                        @end="drag = false"
                        :move="checkMove"
                        handle=".dragIcon"
                        :animation="200"
                      >
                        <h3
                          v-for="(child, childIndex) in item.children"
                          :key="child.id"
                          @dblclick="editItem(child, 'h3')"
                        >
                          <a-input
                            v-if="child.editing && child.level === 3"
                            v-model="child.title"
                            @blur="saveEdit(child)"
                            autofocus
                          />
                          <div class="title" v-else>{{ child.title }}</div>
                          <div class="action-buttons">
                            <a-icon type="drag" style="cursor: move;" class="dragIcon" />
                            <img
                              src="@/assets/icons/icon_sc.png"
                              alt=""
                              srcset=""
                              style="width: 16px;"
                              @click="deleteItem(child, childIndex, 'h3', index)"
                            />
                            <!-- <a-icon type="delete" @click="deleteItem(child, childIndex, 'h3', index)" /> -->
                          </div>
                        </h3>
                      </draggable>
                    </div>
                  </draggable>
                </div>
                <div class="stop-text" v-if="isStop">{{ $t('generationCourse.generationStopped') }}</div>
                <a-button class="stopBtn" v-if="!outputCompleted" @click="stopGenerate">
                  {{ $t('generationCourse.stopGeneration') }}
                </a-button>
                <div class="action" v-else>
                  <div>
                    <a-tooltip placement="bottom">
                      <template slot="title">
                        <span>{{ $t('generationCourse.regenerate') }}</span>
                      </template>
                      <img src="@/assets/icons/icon_reload@2x.png" alt="" style="margin-left: 0px;" srcset="" @click="reload" />
                    </a-tooltip>
                    <a-tooltip placement="bottom">
                      <template slot="title">
                        <span>{{ $t('generationCourse.downloadExcel') }}</span>
                      </template>
                      <img src="@/assets/icons/icon_download@2x.png" alt="" srcset="" @click="exportExcel" />
                    </a-tooltip>
                  </div>
                  <div>
                    <a-button @click="applyToCourse">{{ $t('generationCourse.applyToCourse') }}</a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <TipModal
      @ok="deleteObj.callback"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
          <p></p>
          <p>${deleteObj.title1}</p>
          <p class='placeholder'>${deleteObj.title2}</p>`
      "
    />
  </div>
</template>

<script>
import { SSE } from '@/utils/sse.js'
import { stopGenerate, getAIChatHistoryDetail } from '@/api/aiApp.js'
import VueMarkdown from 'vue-markdown'
import draggable from 'vuedraggable'
import * as XLSX from 'xlsx'
import CourseGenerationConfig from '@/components/CourseGenerationConfig/index.vue'
import TipModal from '@/components/tipModal/index.vue'
import { course } from '@/data/app.js'
const defaultAppId = course.id

export default {
  name: 'GenerationCourse',
  components: {
    VueMarkdown,
    draggable,
    TipModal,
    CourseGenerationConfig
  },
  data() {
    return {
      outlineMessage: '',
      isEditing: false,
      outlineItems: [],
      taskId: '',
      tempMessage: '',
      outputCompleted: false,
      isStop: false,
      fileList: [],
      editingItem: null,
      drag: false,
      isTimeout: false,
      deleteObj: {
        title1: '',
        title2: '',
        callback: () => {}
      },
      delVisible: false
    }
  },
  mounted() {
    this.conversationId = this.$route.query.conversationId
    if (this.conversationId) {
      this.getHistoryDetail()
    }
  },
  methods: {
    generate(inputParams) {
      // 样式处理
      console.log(this.$refs)
      this.$refs.left.style.width = '300px'
      this.$refs.right.style.flex = 1
      this.$refs.right.style.border = '1px solid #e7e7e7'
      this.$refs.main.style.bacogroundColor = '#fff'
      this.tempInputParams = inputParams

      // 清空生成的内容
      this.tempMessage = ''
      this.outlineMessage = ''
      this.outputCompleted = false
      this.isStop = false
      this.isTimeout = false

      // 设置10秒超时检测
      const timeoutCheck = setTimeout(() => {
        if (!this.tempMessage) {
          this.isTimeout = true
          this.source && this.source.close()
        }
      }, 10000)

      // 准备请求参数
      const params = {
        query: '请根据要求输入',
        inputs: inputParams.inputs,
        response_mode: 'streaming',
        conversation_id: '',
        files: inputParams.files
      }

      this.source = new SSE('/ai_app/chat-messages', {
        headers: {
          'X-App-Id': defaultAppId
        },
        payload: JSON.stringify(params),
        method: 'POST'
      })
      this.source.addEventListener('message', e => {
        // 收到消息时清除超时检测
        clearTimeout(timeoutCheck)

        const res = JSON.parse(e.data)
        if (res.event === 'message') {
          this.tempMessage += res.answer
          this.taskId = res.task_id
          // 添加滚动条自动滚动
          this.$nextTick(() => {
            if (!this.$refs.outline) return
            const contentDiv = this.$refs.outline.querySelector('.content')
            if (contentDiv) {
              contentDiv.scrollTop = contentDiv.scrollHeight
            }
          })
        } else if (res.event === 'message_end') {
          this.outlineMessage = this.markdownToJsonWithIds(this.tempMessage)
          this.outputCompleted = true
        }
      })
      this.source.addEventListener('error', event => {})
    },
    markdownToJsonWithIds(markdownText) {
      const lines = markdownText.split('\n').filter(line => line.trim() !== '')
      const result = []
      let currentH2 = null
      let h2Index = 0
      let h3Index = 0

      lines.forEach(line => {
        if (line.startsWith('## ')) {
          // 二级标题作为顶层
          h2Index++
          h3Index = 0 // 重置三级标题索引
          currentH2 = {
            id: `h2-${h2Index}`,
            level: 2,
            title: line.replace('## ', '').trim(),
            children: []
          }
          result.push(currentH2)
        } else if (line.startsWith('### ')) {
          // 三级标题
          h3Index++
          const h3 = {
            id: `h3-${h2Index}-${h3Index}`,
            level: 3,
            title: line.replace('### ', '').trim(),
            children: []
          }
          if (currentH2) {
            currentH2.children.push(h3)
          } else {
            // 如果没有二级标题，直接添加到结果
            result.push(h3)
          }
        }
        // 忽略一级标题（# 开头的行）
      })

      return JSON.parse(JSON.stringify(result, null, 2))
    },
    stopGenerate() {
      this.isStop = true
      stopGenerate(this.taskId, {
        'X-App-Id': defaultAppId
      }).then(res => {
        if (res.result === 'success') {
          this.$message.success('停止生成成功')
        }
      })
    },
    reload() {
      this.outlineMessage = ''
      this.tempMessage = ''
      this.outputCompleted = false
      this.isStop = false
      this.taskId = null
      this.generate(this.tempInputParams)
    },
    editItem(item, level) {
      // 先清除所有项的编辑状态
      this.clearAllEditingStates()
      // 然后设置当前项为编辑状态
      this.$set(item, 'editing', true)
      this.editingItem = item

      // 使用$nextTick确保DOM更新完成后再聚焦输入框
      this.$nextTick(() => {
        const input = this.$refs.outline.querySelector('.ant-input')
        if (input) {
          input.focus()
          // 添加回车键事件监听
          input.addEventListener('keydown', this.handleEnterKey.bind(this, item, level))
        }
      })
    },
    handleEnterKey(item, level, event) {
      if (event.key === 'Enter') {
        event.preventDefault()
        this.addSiblingItem(item, level)
      }
    },
    addSiblingItem(item, level) {
      const parentArray = this.findParentArray(item)
      if (parentArray) {
        const index = parentArray.findIndex(i => i.id === item.id)
        const newItem = {
          id: `${level}-${Date.now()}`,
          level: item.level,
          title: this.$t('generationCourse.newTitle'),
          children: [],
          editing: true
        }
        parentArray.splice(index + 1, 0, newItem)

        this.$nextTick(() => {
          const inputs = this.$refs.outline.querySelectorAll('.ant-input')
          if (inputs[index + 1]) {
            inputs[index + 1].focus()
          }
        })
      }
    },
    findParentArray(item) {
      // 查找当前项的父级数组
      for (const chapter of this.outlineMessage) {
        if (chapter.id === item.id) {
          return this.outlineMessage
        }
        for (const section of chapter.children) {
          if (section.id === item.id) {
            return chapter.children
          }
        }
      }
      return null
    },
    saveEdit(item) {
      this.$set(item, 'editing', false)
      this.editingItem = null
      // 移除回车键事件监听
      const input = this.$refs.outline.querySelector('.ant-input')
      if (input) {
        input.removeEventListener('keydown', this.handleEnterKey)
      }
      // 这里可以添加保存逻辑，比如调用API更新数据
    },
    clearAllEditingStates() {
      // 清除所有章节的编辑状态
      this.outlineMessage.forEach(chapter => {
        this.$set(chapter, 'editing', false)
        // 清除所有子章节的编辑状态
        if (chapter.children) {
          chapter.children.forEach(section => {
            this.$set(section, 'editing', false)
          })
        }
      })
    },
    deleteItem(item, index, level, parentIndex) {
      if (level === 'h2') {
        // 删除章节
        this.deleteObj.title1 = this.$t('generationCourse.deleteChapter.title')
        this.deleteObj.title2 = this.$t('generationCourse.deleteChapter.subtitle')
        this.deleteObj.callback = () => {
          this.outlineMessage.splice(index, 1)
          this.delVisible = false
        }
        this.delVisible = true
      } else if (level === 'h3') {
        // 删除子章节
        this.deleteObj.title1 = this.$t('generationCourse.deleteSection.title')
        this.deleteObj.title2 = this.$t('generationCourse.deleteSection.subtitle')
        this.deleteObj.callback = () => {
          this.outlineMessage[parentIndex].children.splice(index, 1)
          this.delVisible = false
        }
        this.delVisible = true
      }
      // 这里可以添加API调用，将删除操作同步到服务器
    },
    checkMove(evt) {
      // 只允许同一层级的节点之间拖动
      const draggedItemLevel = evt.draggedContext.element.level
      const targetItemLevel = evt.relatedContext.element.level
      return draggedItemLevel === targetItemLevel
    },
    exportExcel() {
      // 1. 准备数据
      const data = []
      this.outlineMessage.forEach(chapter => {
        chapter.children.forEach(section => {
          data.push({
            [this.$t('generationCourse.excelColumns.chapterName')]: chapter.title,
            [this.$t('generationCourse.excelColumns.sectionName')]: section.title
          })
        })
      })
      // 2. 创建工作簿和工作表
      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

      // 3. 计算合并范围
      const merges = []
      let startRow = 1 // 从第2行开始（第1行是表头）
      const chapterNameKey = this.$t('generationCourse.excelColumns.chapterName')
      let currentChapter = data[0][chapterNameKey]

      for (let i = 1; i < data.length; i++) {
        if (data[i][chapterNameKey] === currentChapter) {
          continue
        } else {
          // 添加合并范围（A列，从startRow到i行）
          if (startRow < i) {
            merges.push({ s: { r: startRow, c: 0 }, e: { r: i, c: 0 } })
          }
          currentChapter = data[i][chapterNameKey]
          startRow = i + 1
        }
      }

      // 添加最后一组合并
      if (startRow < data.length) {
        merges.push({ s: { r: startRow, c: 0 }, e: { r: data.length, c: 0 } })
      }

      // 4. 设置合并单元格
      ws['!merges'] = merges

      // 3. 导出 Excel 文件
      XLSX.writeFile(wb, '智能生成课程_' + new Date().getTime() + '.xlsx')
    },
    applyToCourse() {
      if (this.outlineMessage.length === 0) return
      const data = this.outlineMessage.map(chapter => {
        return {
          name: chapter.title,
          children: chapter.children.map(section => ({ name: section.title }))
        }
      })
      this.$store.commit('SET_BATCHLESSON', data)

      this.$router.push({
        name: 'addCourses',
        query: {
          type: 'import'
        }
      })
      console.log('应用数据', data)
    },
    clearForm() {
      // 清空表单
      this.form.resetFields()
      // 清空文件列表
      this.fileList = []
      // 清空生成的内容
      this.tempMessage = ''
      this.outlineMessage = ''
      this.outputCompleted = false
      // 清空任务ID
      this.taskId = ''
      // 重置布局
      this.$refs.left.style.width = '500px'
      this.$refs.right.style.flex = 0
      this.$refs.right.style.border = 'none'
    },
    selectKnowledge(item) {
      console.log('item', item)
      this.selectKnowledgeObj = item
    },
    back() {
      this.$router.back()
    },
    async getHistoryDetail() {
      const res = await getAIChatHistoryDetail(
        {
          conversation_id: this.conversationId,
          first_id: null,
          limit: 20
        },
        {
          'X-App-Id': defaultAppId
        }
      )
      if (res && res.data && res.data.length > 0) {
        const { answer, inputs, messageFiles } = res.data[0]
        console.log(answer, inputs)
        this.setData(answer, inputs, messageFiles)
      }
    },
    setData(answer, inputs, messageFiles) {
      this.$refs.left.style.width = '300px'
      this.$refs.right.style.flex = 1
      this.$refs.right.style.border = '1px solid #e7e7e7'
      this.$refs.main.style.bacogroundColor = '#fff'

      this.tempMessage = answer
      this.outlineMessage = this.markdownToJsonWithIds(answer)
      this.outputCompleted = true
      this.inputs = inputs
      this.$refs.config.initData(inputs, messageFiles)
    }
  },
  watch: {
    delVisible(val) {
      console.log('delVisible', val)
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 18px 21px;
  .main {
    display: flex;
    justify-content: center;
    height: calc(100vh - 180px);
    border-radius: 10px;
    .left {
      width: 500px;
      height: 100%;
      padding-right: 15px;
      padding-top: 30px;
      padding-left: 10px;
      position: relative;
    }
    .right {
      width: 0px;
      // flex: 1;
      height: 100%;
      background: #fafafa;
      display: flex;
      border: none;
      border-radius: 10px;
      // justify-content: center;
      align-items: center;
      overflow: hidden;
      .stop-text{
        font-weight: 600;
        font-size: 12px;
        color: #9E9E9E;
        padding-top: 17px;
      }

      .stopBtn {
        border-radius: 30px;
        color: #6aa2eb;
        border-color: #b5c5da;
        margin-top: 10px;
        padding: 0 10px;
        // margin-left: 20px;
      }
      > div {
        width: 100%;
        height: 100%;
        padding: 26px 33px;
      }
      .outline {
        display: flex;
        // background: #fff;
        width: 100%;
        height: calc(100%);
        position: relative;
        // margin-top: 40px;
        .cover {
          width: 42px;
          height: 42px;
          margin-top: 54px;
          margin-left: 40px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .content {
          margin-top: 42px;
          flex: 1;
          height: calc(100% - 80px);
          overflow: auto;
          margin-right: 10px;
          /deep/ .ant-input {
            width: 500px;
            margin-left: -12px;
          }
        }
        .action-buttons {
          display: none;
          z-index: 999;
          font-size: 15px;
          color: #536471;
          margin-left: 40px;
          justify-content: flex-start;
          align-items: center;
          i {
            margin-right: 10px;
          }
        }
        .tips {
          position: absolute;
          right: 30px;
          top: 10px;
          img {
            &:hover {
              content: url('~@/assets/icons/icon_w_d@2x.png');
            }
          }
        }
      }
      .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #0d2340;
        font-size: 14px;
        flex-direction: column;
        font-weight: bold;
        img {
          width: 76px;
        }
      }
      .action {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        img {
          width: 25px;
          margin-left: 20px;
          cursor: pointer;
        }
        /deep/ .ant-btn {
          color: #ff8d29;
          background-color: #fff;
          border-color: #ff8d29;
        }
      }
      .timeout {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 180px;
        }
      }
    }
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
.markdown-body {
  padding: 0px 20px;
  margin: 0 auto;
  border-left: solid 1px #ccc;
  /deep/ h2 {
    position: relative;
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  /deep/ h3 {
    font-size: 14px;
    color: #3b3b3b;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  > div {
    &:first-child {
      /deep/ h2 {
        margin-top: 0;
      }
    }
    > div {
      &:last-child {
        position: relative;
        // &::before {
        //   position: absolute;
        //   left: -24px;
        //   top: 37px;
        //   content: '';
        //   display: block;
        //   width: 4px;
        //   height: 49px;
        //   background-color: #fafafa;
        // }
      }
      &:first-child {
        position: relative;
        // &::before {
        //   position: absolute;
        //   left: -24px;
        //   top: -35px;
        //   content: '';
        //   display: block;
        //   width: 4px;
        //   height: 49px;
        //   background-color: #fff;
        // }
      }
    }
  }
}
.vue-markdown {
  /deep/ h2 {
    &:first-child {
      margin-top: 0;
    }
  }
}

.completed {
  h2,
  h3 {
    margin-bottom: 0;
    padding-left: 2px;
    cursor: pointer;
    &:hover {
      background-color: #f7f7f7;
      border-radius: 4px;
      margin-left: -10px;
      padding-left: 12px;
      .action-buttons {
        display: flex !important;
      }
      &::after {
        left: -14px;
      }
    }
    /deep/ .ant-input {
      width: 100%;
      font-size: inherit;
      font-weight: inherit;
      height: 25px;
    }
    .title {
      // width: 500px;
    }
  }
  h2 {
    height: 40px;
    line-height: 40px;
    /deep/ .ant-input {
      height: 30px;
    }
    &::after {
      position: absolute;
      left: -24px;
      top: 17px;
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background-color: #ccc;
    }
  }
  h3 {
    height: 30px;
    line-height: 30px;
    // padding: 2px 0px;
  }
}

.title-text {
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
}
</style>
